import { createContext } from "react";

const ConnectionProfileFieldsContext = createContext<{
    isTestInProgress: boolean;
    isTestButtonEnabled: boolean;
    testConnectionResponse: {
        result: boolean;
        message: string;
        hide?: boolean;
    }[];
}>(null);

export default ConnectionProfileFieldsContext;
